import React from 'react';
import { connect } from 'dva';
import { Form, Input, Button, Checkbox} from 'antd';
import { injectStripe, CardElement, CardNumberElement, CardExpiryElement} from 'react-stripe-elements';
import FormComponent from '../../../components/FormComponent';
import Dimio from '../../../components/Dimio';
import config from '../config/config';

const {fields, setApi, stripeStyle} = config.payment;

const ErrorMessages = {
  'jcb': 'JCBのカードはオンライン支払いサービスをご利用いただけません。トラトラへ電話にてお問い合わせください。'
};

class PaymentFormBase extends FormComponent {
  constructor(props) {
    super(props);

    this.state = {
      readTC: false,
      cardError: null,
      initState: true
    };

    this.handleSubmit = this.handleSubmit.bind(this);
//    this.setRef = this.setRef.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.onChange = this.onChange.bind(this);
    //this.handleElement = this.handleElement.bind(this);
  }

  componentDidMount() {
    const {payment, form} = this.props;

    const map = ['email', 'name', 'phone', 'amount'];
    let initialValues = {};
//    debugger;

    if(form) {
      for (let key of map) {
        if (payment[key]) {
          initialValues[key] = payment[key];
        }
      }
      console.info(initialValues);
      form.setFieldsValue(initialValues);
//      form.setFields({key: {value:payment[key]}});
    }
  }

  /*
  setRef(e){
    //    console.info(e);
    this.setState({element: e});
  }
  */

  handleBlur(){
    const {stripe} = this.props;
//    console.info('blur', e);
    console.info('blur', stripe);
  }

  onChange(stripe){
    console.info('change',stripe);
    if(stripe.brand == 'jcb'){
      this.setState({cardError: ErrorMessages.jcb});
    }else{
      this.setState({cardError: null});
    }

    if(stripe.complete){
      this.setState({readTC:true, cardError: null, initState:false});
    }else if(stripe.error){
      this.setState({cardError: stripe.error.message});
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    const {form, stripe, dispatch, payment} = this.props;
    const self = this;

    form.validateFieldsAndScroll((err, values) => {
//      console.info(stripe.elements());
      console.info(stripe);
//      console.info(this.state.element);

      if (!err) {
        self.showLoading();
/*
        stripe.createToken({name: values.name})
          .then(({token, error}) => {
//          console.info(values);
//          console.log('Received Stripe token:', token);

          if(error){
            console.info(error);
            self.showError(error.message);
            self.hideLoading();
            this.setState({cardError: error.message});
          }else{
            //          if(token) {
            const _data = values;
            _data.token = token;
//        _data.amount = payment.amount;
            _data.test = payment.test;

            this.save(setApi, {
              data: _data,
              onSuccess(res){
                console.info(res);
                self.hideError();

                //alert('Thank youページ作りましょう');
                window.location.href = '/payment/thankyou';
                self.hideLoading();
              },
              onError(err){
                self.hideLoading();
                self.showError(err.error);
              }
            });
          }
        });
        */
      }
    });
  }

  render() {
    const Field = this.Field;
    const Submit = this.Submit;
    const {payment} = this.props;

    const AvailableCards = () => (
      <div className="row row-all-5" style={{maxWidth:'480px'}}>
        <div className="col">
          <img className="img-rounded img-thumbnail" alt="" src="//tora-tora.net/themes/travel/dev/images/logo/visa.png" />
        </div>
        <div className="col">
          <img className="img-rounded img-thumbnail" alt="" src="//tora-tora.net/themes/travel/dev/images/logo/mastercard.png" />
        </div>
        <div className="col">
          <img className="img-rounded img-thumbnail" alt="" src="//tora-tora.net/themes/travel/dev/images/logo/amex.png" />
        </div>
        <div className="col">
          <img className="img-rounded img-thumbnail" alt="" src="//tora-tora.net/img/travel/discover.png" />
        </div>
      </div>
    );

    return (
      <Form onSubmit={this.handleSubmit}>
        <section className='mb-5'>
          <header>
            <h2 className="payment-page__subtitle">お支払金額をご確認ください</h2>
          </header>
          <Field {...fields.amount}>
            <Input addonBefore='AUD' type='tel'/>
          </Field>
        </section>

        <section className='mb-5'>
          <header>
            <h2 className="payment-page__subtitle">お客様情報の確認</h2>
          </header>
          <Field {...fields.name}>
            <Input placeholder='Taro Yamada'/>
          </Field>
          <Field {...fields.email}>
            <Input  type="email" placeholder='tom@exemple.com'/>
          </Field>

          <Field {...fields.phone}>
            <Input  type="tel"/>
          </Field>

          {/*
          <Field
            {...fields.recurring}
          >
            <Checkbox>{fields.recurring.label}</Checkbox>
          </Field>
          */}
        </section>

        <section className='mb-5'>
          <header>
            <h2 className="payment-page__subtitle">支払い目的を入力する</h2>
          </header>
          <Form.Item
            className={this.state.cardError?"payment-field error":"payment-field"}
            label={fields.payment.label}
          >
            <CardElement
              elementRef={e => this.element = e}
              className={this.state.initState?'initState':''}
              //              value={{postalCode: '11111'}}
              //              hidePostalCode={true}
              style={stripeStyle}
              onBlur={this.handleBlur}
              onChange={this.onChange}
              //onChange={this.handleElement}
            />
          </Form.Item>
          {this.state.cardError &&
          <div className="card-error" role="alert">{this.state.cardError}</div>
          }
          <AvailableCards />
          <Field {...fields.enquiry}>
            <Input.TextArea rows={3} placeholder='支払い目的や質問事項など'/>
          </Field>
        </section>

        {/*
        <section className="my-3">
          <Checkbox onChange={(e) => this.setState({readTC: e.target.checked})}>利用規約に同意する <a href="terms_service" target="_blank">Terms of Services</a></Checkbox>
        </section>
*/}
        <Submit
          className="btn-block btn-success btn-lg"
          disabled={!this.state.readTC}>
          オンライン決済する
        </Submit>
      </Form>
    );
  }
}

let init = false;
const InitForm = {
  mapPropsToFields(props) {
    const {payment} = props;

//    debugger;
    if(!init) {
      const map = ['email', 'name', 'phone', 'amount'];

      const initValues = {};
      for (let key of map) {
        if (payment[key]) {
          initValues[key] = Form.createFormField({value: payment[key]})
        }
      }
      console.info('init', initValues);
      /*
      const _set = (value) => {
        return Form.createFormField({value: value});
      }
  */
      init = true;
      return initValues;
    }else{
//      debugger;
      return;
    }

  }
};

/*
const mapState = (state, ownProps) => {
  return {
    core: state.core,
    payment: state.payment,
    initialValues: {
      email: 'ken@dimio.net',
     },
  }
}
*/

//const PaymentForm = Form.create(InitForm)(PaymentFormBase);
const PaymentForm = Form.create()(PaymentFormBase);
//export default injectStripe(PaymentForm);
//export default connect(mapState)(injectStripe(PaymentForm));

export default connect(({ payment }) => ({
  payment
}))(injectStripe(PaymentForm));




// WEBPACK FOOTER //
// ./src/pages/payment/components/PaymentForm.js